<style scoped>
</style>
<template>
  <list ref="list"></list>
</template>

<script>
  import list from "../../../components/approval/list";
  export default {
    name: "submission",//发起
    components: {list},
  }
</script>
